import { Route } from 'react-router-dom';
import { Redirect, Switch, useParams, useRouteMatch } from 'react-router';
import { FeaturedEntryPage } from '../entrypages/featured/FeaturedEntryPage';
import { PageNotFound } from '../PageNotFound';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';
import React, { FC } from 'react';
import useShopLanguages from '../../shared/hooks/useShopLanguages';
import { LibxFeaturedEntryPage } from '../../yourborrowbox/libx/LibxFeaturedEntryPage';
import LibxProductDetailPage from '../../yourborrowbox/libx/productdetail/LibxProductDetailPage';
import { NewlyAddedPage } from '../../yourborrowbox/libx/NewlyAddedPage';
import { AllTitlesPage } from '../../yourborrowbox/libx/AllTitlesPage';
import { LibxGenresContainer } from '../../yourborrowbox/libx/genres/LibxGenresContainer';
import { LocalRegionsPage } from '../../yourborrowbox/libx/localregions/LocalRegionsPage';
import CampaignProductsRouteSwitch from '../campaigns/CampaignProductsRouteSwitch';
import { FeaturedForeignLanguageEntryPage } from '../language/languagelearning/FeaturedForeignLanguageEntryPage';
import { LanguageLearningProductsPage } from '../language/languagelearning/allproducts/LanguageLearningProductsPage';
import { CatalogueTemplate } from './CatalogueTemplate';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';
import { LocalRegionsRedirect } from '../../yourborrowbox/libx/localregions/LocalRegionsRedirect';

export const ShopTemplate: FC = () => {
    const { path, url } = useRouteMatch();
    const { shopLanguage } = useParams<{ shopLanguage: string }>();
    const shopLanguages = useShopLanguages();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    if (!isMultiLanguageShopEnabled) {
        return <Redirect to="/catalogue" />;
    }

    if ([...shopLanguages.map(shopLanguage => shopLanguage.shopLanguageId), 'other', 'all'].indexOf(shopLanguage) < 0) {
        return <Redirect to="/shop" />;
    }

    return (
        <Switch>
            <Route path={`${path}/featured`}>
                <FeaturedEntryPage />
            </Route>
            <Route exact path={path}>
                <Redirect to={`${url}/featured`} />
            </Route>

            <Route path={`${path}/languagelearning/:languageId/products/:loanFormat`}>
                <CheckLoanFormat>
                    <LanguageLearningProductsPage />
                </CheckLoanFormat>
            </Route>
            <Route path={`${path}/languagelearning/:loanFormat`}>
                <CheckLoanFormat>
                    <FeaturedForeignLanguageEntryPage />
                </CheckLoanFormat>
            </Route>
            <Route exact path={`${path}/languagelearning`}>
                <Redirect to={`${url}/languagelearning/all`} />
            </Route>

            <Route exact path={`${path}/libxchange`}>
                <Redirect to={`${url}/libxchange/featured`} />
            </Route>
            <Route path={`${path}/libxchange/products/:productId`}>
                <LibxProductDetailPage />
            </Route>
            <Route path={`${path}/libxchange/featured`}>
                <LibxFeaturedEntryPage />
            </Route>
            <Route path={`${path}/libxchange/newlyadded`}>
                <NewlyAddedPage />
            </Route>
            <Route path={`${path}/libxchange/products`}>
                <AllTitlesPage />
            </Route>
            <Route path={`${path}/libxchange/genres/:genre?/:subGenre?`}>
                <LibxGenresContainer />
            </Route>
            <Route exact path={`${path}/libxchange/localregions`}>
                <LocalRegionsRedirect />
            </Route>
            <Route path={`${path}/libxchange/localregions/:level1/:level2?`}>
                <LocalRegionsPage />
            </Route>

            <Route path={`${path}/unlimited/campaigns`}>
                <CampaignProductsRouteSwitch />
            </Route>
            <Route exact path={`${path}/unlimited`}>
                <Redirect to={`${url}/unlimited/campaigns`} />
            </Route>

            <Route path={`${path}/:loanFormat`}>
                <CheckLoanFormat>
                    <CatalogueTemplate />
                </CheckLoanFormat>
            </Route>

            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};
